/* eslint-disable import/named */
// Version: 1.0.13

import store from './redux/store';
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { Provider } from 'react-redux';
import { ApolloProvider } from '@apollo/client';
import apolloClient, { websocketClient } from './apolloClient';
import { SnackbarProvider } from 'notistack';
import { HistoryRouter } from './routes/HistoryRouter';
import history from './routes/history';
import { CollapseDrawerProvider } from './contexts/CollapseDrawerContext';
import { SettingsProvider } from './contexts/SettingsContext';
import { HelmetProvider } from 'react-helmet-async';
import WebSocketContextProvider from './contexts/WebSocketContext';
import './i18n';
// css
import 'react-perfect-scrollbar/dist/css/styles.css';
import 'simplebar-react/dist/simplebar.min.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <HelmetProvider>
    <Provider store={store}>
      <SnackbarProvider maxSnack={3} preventDuplicate autoHideDuration={2000}>
        <ApolloProvider client={apolloClient}>
          <CollapseDrawerProvider>
            <SettingsProvider>
              <HistoryRouter history={history}>
                <WebSocketContextProvider client={websocketClient}>
                  <App />
                </WebSocketContextProvider>
              </HistoryRouter>
            </SettingsProvider>
          </CollapseDrawerProvider>
        </ApolloProvider>
      </SnackbarProvider>
    </Provider>
  </HelmetProvider>
);
